// extracted by mini-css-extract-plugin
export default {"container":"Owner_container__01XP8","page":"Owner_page__7T19F","section":"Owner_section__Pkqhc"};